import { FC } from "react";

import { Stack, useMultiStyleConfig } from "@chakra-ui/react";

import Divider from "./StepDivider";
import StepNode from "./StepNode";
import { TStepsProps } from "./types";
import getStepEvaluations from "./utils/getStepEvaluations";

const getKey = (step: string, index: number) => `step-${step}-${index}`;

const Steps: FC<TStepsProps> = ({ isVertical = true, steps, currentStepIndex = 0, isComplete = false }) => {
  const styles = useMultiStyleConfig("Steps", {});

  return (
    <Stack
      direction={isVertical ? "column" : "row"}
      justify={isVertical ? "start" : "space-between"}
      divider={<Divider isVertical={isVertical} />}
    >
      {steps.map(({ label, href, onClick }, index) => {
        const { isPreviousOrCurrentStep, isPreviousStep, stepNumber } = getStepEvaluations(index, currentStepIndex);
        return (
          <StepNode
            key={getKey(label, index)}
            isComplete={isComplete}
            isPreviousOrCurrentStep={isPreviousOrCurrentStep}
            styles={styles}
            isPreviousStep={isPreviousStep}
            stepNumber={stepNumber}
            href={href}
            onClick={onClick}
            label={isVertical ? label : undefined}
          />
        );
      })}
    </Stack>
  );
};

export default Steps;
